import React from 'react';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';

// function map(item)
// {
//     return {...item, id: item.tagID}
// }

async function getData()
{
    let response = await api.organization.getSingle();
    let data = await response.json();
    // data = data.map((item)=>map(item));
    
    return data;
}

const OrganizationCtx = React.createContext({
    loading: true, 
    data: {
        organizationID: 0,
        name: "",
        userLimit: 0
    }, 
    // funcs: {
    //     create: () => {},
    //     update: () => {},
    //     archive: () => {},
    //     restore: () => {},
    //     delete: () => {},
    // }
});

function OrganizationCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({organizationID: 0, name: "", userLimit: 0});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalUpdate = React.useCallback((newData) => {
        setData(newData);
    }, []);


    React.useEffect( function handleNotifications() {

        const handleUpdate = (message) => internalUpdate(message);
        Singletons.NotificationsSocket.on('organizations.updated', handleUpdate);

        return () => {
            Singletons.NotificationsSocket.off('organizations.updated', handleUpdate);
        }

    }, [internalUpdate]);

    return <OrganizationCtx.Provider value={{loading: loading, data: {...data}}} >
        {props.children}
        </OrganizationCtx.Provider>
}

export {OrganizationCtx, OrganizationCtxProvider};